<template>
  <div>
    <div class="card">
      <div class="card-content">
        <h4 class="card-title">Reporte de Cumplimiento</h4>
        <div class="row">
          <div class="col-md-3 form-group">
            <label>Estatus</label><br>
            <el-select clearable class="select-default" filterable name="estatus" placeholder="Estatus" v-model="model.estatus">
              <el-option v-for="option in estatus" class="select-default" :value="option.id" :label="option.estatus" :key="option.estatus">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-3">
            <label>Declaración </label><br>
            <el-select clearable class="select-default" filterable name="declaracion" placeholder="Declaracion" v-model="model.tipo_declaracion">
              <el-option v-for="option in tiposDeclaracion" class="select-default" :value="option.id" :label="option.tipo_declaracion" :key="option.tipo_declaracion">
              </el-option>
            </el-select>
          </div>
          <div v-if="getKey('permisos').includes(16)" class="col-md-3">
            <label>Dependencia </label><br>
            <el-select clearable class="select-default" filterable name="dependencia" placeholder="Dependencia" v-model="model.dependencia_id">
              <el-option v-for="option in dependencias" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-3">
            <label>Año</label><br>
            <el-select clearable class="select-default" filterable name="periodo" placeholder="Periodo" v-model="model.periodo">
              <el-option v-for="option in periodos" class="select-default" :value="option.year" :label="option.year" :key="option.year">
              </el-option>
            </el-select>
          </div>


        </div>
        <br>
        <button @click="getCumplimiento" class="btn btn-fill btn-success pull-right">
          Buscar
        </button>
        <br><br><br>

        <div v-if="mostrar">
          <br>
          <h4 class="card-title text-center">Cumplimiento</h4>
          <div class="row">
            <div class="col-sm-12">

              <export-excel class="btn btn-wd btn-success" :data="json_data" :meta="json_meta" :fields="json_fields" worksheet="My Worksheet" name="Cumplimiento.xls">
                <span class="btn-label">
                  <i class="fa fa-file-excel"></i>
                </span>
                Descargar Reporte
              </export-excel>
              <div class="pull-right">
                <label>
                  <input type="search" class="form-control input-sm" placeholder="Buscar" v-model="searchQuery" aria-controls="datatables">
                </label>
              </div>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <el-table class="table-striped table-responsive" :data="queriedData" border style="width: 100%" :row-class-name="tableRowClassName">
                <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" :class-name="column.class">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>


      </div>
    </div>

  </div>
</template>
<script>
  import Vue from 'vue'
  import excel from 'vue-excel-export'

  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import Loading from 'src/components/Dashboard/Layout/LoadingMainPanel.vue'
  import moment from 'moment'

  import {
    Table,
    TableColumn,
    Select,
    Option
  } from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)

  Vue.use(excel)

  export default {
    components: {
      StatsCard,
      ChartCard,
      CircleChartCard,
      PPagination
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data() {
      return {
        model: {
          tipo_declaracion: '',
          dependencia_id: 0,
          periodo: '',
          estatus: 1
        },
        dependencias: {},
        rol: '',
        periodos: [],
        mostrar: false,
        tiposDeclaracion: [{
          'id': 1,
          'tipo_declaracion': 'Inicial'
        }, {
          'id': 2,
          'tipo_declaracion': 'Anual'
        }, {
          'id': 3,
          'tipo_declaracion': 'Final'
        }, {
          'id': 4,
          'tipo_declaracion': 'Todas'
        }],
        estatus: [{
          'id': 1,
          'estatus': 'Activos'
        }, {
          'id': 2,
          'estatus': 'Bajas'
        }, {
          'id': 3,
          'estatus': 'Todos'
        }],
        list_cumplimiento: [],
        json_fields: {
          'Dependencia': 'dependencia',
          'Obligados': 'obligados',
          'Cumplidos': 'cumplidos',
          'Individual': 'individual',
          'Faltantes': 'faltante',
          'Total': 'total'
        },
        json_data: [],
        json_meta: [
          [{
            'key': 'charset',
            'value': 'utf-8'
          }]
        ],
        pagination: {
          perPage: 15,
          currentPage: 1,
          perPageOptions: [15, 30, 45, 60],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['rfc', 'nombres', 'cargo'],
        tableColumns: [{
            prop: 'dependencia',
            label: 'Dependencia',
            minWidth: 200,
            class: 'text-left'
          },
          {
            prop: 'obligados',
            label: 'Obligados',
            minWidth: 70,
            class: 'text-right'
          },
          {
            prop: 'cumplidos',
            label: 'Cumplidos',
            minWidth: 70,
            class: 'text-right'
          },
          {
            prop: 'faltante',
            label: 'Faltantes',
            minWidth: 75,
            class: 'text-right'
          },
          {
            prop: 'individual',
            label: '% Individual',
            minWidth: 70,
            class: 'text-right'
          },
          {
            prop: 'total',
            label: 'Total',
            minWidth: 75,
            class: 'text-right'
          },
        ]
      }
    },
    computed: {
      pagedData() {
        return this.list_cumplimiento
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData() {
        if (!this.searchQuery) {
          this.pagination.total = this.list_cumplimiento.length
          return this.pagedData
        }
        let result = this.list_cumplimiento
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      }
    },
    created() {
      this.checkPermissions();
      this.getDependencias();
      this.getTipoDeclaracion();
      this.getPeriodos();
      this.rol = this.getKey('role');
      if (this.getKey('permisos').includes(16)) {
        this.model = {
          tipo_declaracion: 2,
          dependencia_id: 0,
          periodo: 2020,
          estatus: 3
        }

        // this.getCumplimiento()
      }

    },
    watch: {
      '$route': 'checkPermissions'
    },
    methods: {
      checkPermissions() {
        let permiso = [12, 16];
        if (!this.getKey('permisos').some(r => permiso.includes(r))) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();
        }
      },
      tableRowClassName({
        row,
        rowIndex
      }) {
        if (row.dependencia === "TOTAL")
          return 'text-right totales';
        else
          return 'text-right'
      },
      getDependencias() {
        var v = this;
        this.$http.get("cat_ente_publico").then(
          response => {
            this.dependencias = response.data.entes_publicos;
            this.dependencias.push({
              'codigo': 'T',
              'id': 0,
              'valor': 'TODAS'
            });
          },
          error => {
            this.StepError(error);
          }
        );

      },
      getTipoDeclaracion() {},
      getPeriodos() {
        var v = this;
        this.$http.get("getPeriodos").then(
          response => {
            this.periodos = response.data.periodos;
          },
          error => {
            this.StepError(error);
          }
        );
      },
      getCumplimiento() {
        if (!this.getKey('permisos').includes(16)) //permiso de cumplimiento global
          this.model.dependencia_id = this.getKey('ente_publico_id')

        let url

        if (this.model.estatus == 1)
          url = "cumplimientoAct2"
        else if (this.model.estatus == 2)
          url = "cumplimientoBj2"
        else
          url = "cumplimiento2"


        this.$http.post(url, this.model).then(
          response => {

            this.mostrar = true;
            var v = this;
            v.list_cumplimiento = [];
            v.list_cumplimiento.push({
              'dependencia': 'Dependencia',
              'obligados': 'Obligados',
              'cumplidos': 'Cumplidos',
              'faltante': 'Faltantes',
              'individual': '% Individual',
              'total': 'Total',

            });
            $.each(response.data, function (key, value) {
              v.list_cumplimiento.push({
                'dependencia': value.entidad['valor'],
                'obligados': v.group1k(value.obligados),
                'cumplidos': v.group1k(value.cumplidos),
                'faltante': v.group1k(value.faltantes),
                'individual': v.group1k(value.individual) + '%',
                'total': v.group1k(value.total) + '%'

              });
              v.json_data.push({
                'dependencia': value.entidad['valor'],
                'obligados': v.group1k(value.obligados),
                'cumplidos': v.group1k(value.cumplidos),
                'faltante': v.group1k(value.faltantes),
                'individual': v.group1k(value.individual) + '%',
                'total': v.group1k(value.total) + '%'

              });
            });

          },
          error => {
            this.StepError(error);
          }
        );
        // }else{
        //     this.StepW('Llena todos los campos')
        // }
      },
      /*  group1k(s) {

        let s1

            if(s<1000){
                s1 =Number(s).toLocaleString().toString().substring(0,5)
            }else{
                s1 = s.toString()
                    if(s1.length == 6){
                        s1 = s1.split('').reverse().join('').replace(/\d{3}/g, '$&,').split('').reverse().join('')
                        s1 = s1.substring(1,s1.length);
                    }else{
                        s1 = s1.split('').reverse().join('').replace(/\d{3}/g, '$&,').split('').reverse().join('');
                    }

            }

        console.log(s1)

        return s1



      } */
    }
  }

</script>
<style>
  .totales {
    font-weight: bold !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/Cumplimiento2.vue